// InvoicePDF.js - النسخة الأصلية الكاملة
import React from 'react';
import { Document, Page, Text, View, StyleSheet,Font } from '@react-pdf/renderer';


Font.register({
  family: 'Amiri',
  src: process.env.PUBLIC_URL + '/fonts/Amiri-Regular.ttf',
});
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: 'Amiri',
    backgroundColor: '#ffffff',
  },
  headerBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 20,
    backgroundColor: '#2C3E50',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#2C3E50',
    marginTop: 10,
    marginBottom: 10,
  },
  invoiceInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    marginTop: 10,
  },
  invoiceInfoLeft: {
    textAlign: 'left',
  },
  invoiceInfoRight: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: '#2C3E50',
    marginBottom: 10,
  },
  partiesContainer: {
    flexDirection: 'row',
    marginBottom: 10,
    gap: 20,
  },
  partyBox: {
    flex: 1,
    backgroundColor: '#F8F9FA',
    padding: 12,
    borderWidth: 0.5,
    borderColor: '#CCCCCC',
    borderRadius: 4,
  },
  partyTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2C3E50',
    marginBottom: 4,
    backgroundColor: '#E8ECF1',
    padding: 4,
    textAlign: 'center',
  },
  partyRow: {
    flexDirection: 'row',
    marginBottom: 4,
    flexWrap: 'wrap',
  },
  partyLabel: {
    width: 65,
    fontWeight: 'bold',
    fontSize: 9,
    color: '#555',
  },
  partyValue: {
    flex: 1,
    fontSize: 9,
    color: '#333',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#34495E',
    padding: 8,
    marginTop: 4,
    marginBottom: 2,
  },
  tableHeaderCell: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: 9,
    textAlign: 'center',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#CCCCCC',
    padding: 8,
  },
  tableRowEven: {
    backgroundColor: '#F9F9F9',
  },
  tableRowOdd: {
    backgroundColor: '#FFFFFF',
  },
  tableCell: {
    fontSize: 9,
    textAlign: 'center',
  },
  totalsContainer: {
    marginTop: 20,
    alignItems: 'flex-end',
  },
  totalsBox: {
    width: 260,
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5,
  },
  totalLabel: {
    fontWeight: 'bold',
  },
  totalValue: {
    textAlign: 'right',
  },
  netToPay: {
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: 1.5,
    borderTopColor: '#2C3E50',
  },
  netToPayLabel: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#E74C3C',
  },
  netToPayValue: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#E74C3C',
  },
  amountInWords: {
    marginTop: 2,
    padding: 4,
    backgroundColor: '#F8F9FA',
    borderRadius: 4,
  },
  amountInWordsText: {
    fontSize: 9,
    fontWeight: 'bold',
  },
  signatures: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 2,
    marginBottom:2,
  },
  signatureBox: {
    textAlign: 'center',
  },
  signatureText: {
    fontSize: 12,
  },
 signatureLine: {
  marginTop: 0,
  width: 150,
  borderBottomWidth: 0.2,
  borderBottomColor: '#000000',
},
  footer: {
    position: 'absolute',
    bottom: 15,
    left: 40,
    right: 40,
  },
  footerLine: {
    borderBottomWidth: 0.5,
    borderBottomColor: '#7F8C8D',
    marginBottom: 5,
  },
  footerText: {
    fontSize: 7,
    textAlign: 'center',
    color: '#7F8C8D',
  },
  pageNumber: {
    position: 'absolute',
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 8,
    color: '#7F8C8D',
  },
  col1: { width: '7%' },
  col2: { width: '13%' },
  col3: { width: '42%' },
  col4: { width: '10%' },
  col5: { width: '13%' },
  col6: { width: '15%' },
});

// دالة تحويل الأرقام إلى حروف (بالفرنسية)
const convertNumberToFrenchWords = (number) => {
  if (number === 0) return "ZÉRO";
  
  const units = ["", "UN", "DEUX", "TROIS", "QUATRE", "CINQ", "SIX", "SEPT", "HUIT", "NEUF"];
  const teens = ["DIX", "ONZE", "DOUZE", "TREIZE", "QUATORZE", "QUINZE", "SEIZE", "DIX-SEPT", "DIX-HUIT", "DIX-NEUF"];
  const tens = ["", "", "VINGT", "TRENTE", "QUARANTE", "CINQUANTE", "SOIXANTE", "SOIXANTE-DIX", "QUATRE-VINGT", "QUATRE-VINGT-DIX"];
  
  const convert = (n) => {
    if (n < 10) return units[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) {
      const ten = Math.floor(n / 10);
      const unit = n % 10;
      let result = tens[ten];
      if (unit !== 0) {
        if (ten === 7 || ten === 9) result = result.replace("DIX", "");
        result += (ten === 7 || ten === 9 ? "-" : "-") + units[unit];
      }
      if (ten === 7 || ten === 9) result = result.replace("DIX-", "DIX");
      return result;
    }
    if (n < 1000) {
      const hundred = Math.floor(n / 100);
      const rest = n % 100;
      let result = hundred === 1 ? "CENT" : units[hundred] + " CENT";
      if (rest !== 0) result += " " + convert(rest);
      if (hundred > 1 && rest === 0) result += "S";
      return result;
    }
    if (n < 1000000) {
      const thousand = Math.floor(n / 1000);
      const rest = n % 1000;
      let result = thousand === 1 ? "MILLE" : convert(thousand) + " MILLE";
      if (rest !== 0) result += " " + convert(rest);
      return result;
    }
    return String(n);
  };
  
  return convert(number);
};

const convertAmountToFrenchWords = (amount) => {
  const dinars = Math.floor(amount);
  const centimes = Math.round((amount - dinars) * 100);
  let result = "";
  
  if (dinars > 0) {
    result += convertNumberToFrenchWords(dinars);
    result += dinars === 1 ? " DINAR" : " DINARS";
  }
  if (centimes > 0) {
    if (dinars > 0) result += " ET ";
    result += convertNumberToFrenchWords(centimes);
    result += centimes === 1 ? " CENTIME" : " CENTIMES";
  }
  if (dinars === 0 && centimes === 0) return "ZÉRO DINAR";
  return result;
};

// حساب الطابع المالي
const calculateTimbreFiscal = (totalTTC, paymentMethod) => {
  if (paymentMethod !== 'cash' || totalTTC <= 300) return 0;
  let timbre = 0;
  if (totalTTC <= 30000) timbre = totalTTC * 0.01;
  else if (totalTTC <= 100000) timbre = totalTTC * 0.015;
  else timbre = totalTTC * 0.02;
  if (timbre < 5 && totalTTC > 300) timbre = 5;
  return timbre;
};

// الحصول على نص طريقة الدفع
const getPaymentMethodText = (method) => {
  switch (method) {
    case 'cash': return "Paiement en espèces (Cash)";
    case 'cheque': return "Paiement par chèque";
    case 'virement': return "Virement bancaire";
    case 'card': return "Carte bancaire";
    default: return "Paiement en espèces (Cash)";
  }
};

const InvoicePDF = ({ 
  invoiceNumber = "N/A", 
  invoiceDate = new Date().toLocaleDateString('fr-FR'),
  distributor = {}, 
  client = {}, 
  products = [], 
  discountPercent = 0, 
  tvaRate = 0.19, 
  paymentMethod = 'cash', 
  totalPrice = 0, 
  finalPrice = 0 
}) => {
  // حساب المجاميع
  let totalHT = totalPrice || products.reduce((sum, p) => sum + ((p?.price || 0) * (p?.quantity || 0)), 0);
  const discountAmount = totalHT * (discountPercent / 100);
  totalHT = totalHT - discountAmount;
  const tva = totalHT * tvaRate;
  const totalTTC = totalHT + tva;
  const timbreFiscal = calculateTimbreFiscal(totalTTC, paymentMethod);
  const netAPayer = totalTTC + timbreFiscal;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerBar} fixed />
        
        <Text style={styles.title}>FACTURE COMMERCIALE</Text>
        
        <View style={styles.invoiceInfo}>
          <Text style={styles.invoiceInfoLeft}>Date : {invoiceDate}</Text>
          <Text style={styles.invoiceInfoRight}>N° : {invoiceNumber}</Text>
        </View>
        <View style={styles.divider} />
        
        {/* Client et Fournisseur */}
        <View style={styles.partiesContainer}>
          {/* Section CLIENT */}
          <View style={styles.partyBox}>
            <Text style={styles.partyTitle}>CLIENT</Text>
            <View style={styles.partyRow}>
              <Text style={styles.partyLabel}>Nom:</Text>
              <Text style={styles.partyValue}>{client?.name || "---"}</Text>
            </View>
            {client?.activity && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>Activité:</Text>
                <Text style={styles.partyValue}>{client.activity}</Text>
              </View>
            )}
            {client?.rc && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>RC:</Text>
                <Text style={styles.partyValue}>{client.rc}</Text>
              </View>
            )}
            {client?.art && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>NAI:</Text>
                <Text style={styles.partyValue}>{client.art}</Text>
              </View>
            )}
            {client?.nif && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>NIF:</Text>
                <Text style={styles.partyValue}>{client.nif}</Text>
              </View>
            )}
            {client?.nis && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>NIS:</Text>
                <Text style={styles.partyValue}>{client.nis}</Text>
              </View>
            )}
            {client?.phone && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>Tél:</Text>
                <Text style={styles.partyValue}>{client.phone}</Text>
              </View>
            )}
            {client?.address && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>Adresse:</Text>
                <Text style={styles.partyValue}>{client.address}</Text>
              </View>
            )}
          </View>
          
          {/* Section FOURNISSEUR */}
          <View style={styles.partyBox}>
            <Text style={styles.partyTitle}>FOURNISSEUR</Text>
            <View style={styles.partyRow}>
              <Text style={styles.partyLabel}>Nom:</Text>
              <Text style={styles.partyValue}>{distributor?.name || "---"}</Text>
            </View>
            {distributor?.activity && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>Activité:</Text>
                <Text style={styles.partyValue}>{distributor.activity}</Text>
              </View>
            )}
            {distributor?.rc && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>RC:</Text>
                <Text style={styles.partyValue}>{distributor.rc}</Text>
              </View>
            )}
            {distributor?.art && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>NAI:</Text>
                <Text style={styles.partyValue}>{distributor.art}</Text>
              </View>
            )}
            {distributor?.nif && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>NIF:</Text>
                <Text style={styles.partyValue}>{distributor.nif}</Text>
              </View>
            )}
            {distributor?.nis && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>NIS:</Text>
                <Text style={styles.partyValue}>{distributor.nis}</Text>
              </View>
            )}
            {distributor?.phone && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>Tél:</Text>
                <Text style={styles.partyValue}>{distributor.phone}</Text>
              </View>
            )}
            {distributor?.address && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>Adresse:</Text>
                <Text style={styles.partyValue}>{distributor.address}</Text>
              </View>
            )}
            {distributor?.rib && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>RIB:</Text>
                <Text style={styles.partyValue}>{distributor.rib}</Text>
              </View>
            )}
            {distributor?.email && (
              <View style={styles.partyRow}>
                <Text style={styles.partyLabel}>Email:</Text>
                <Text style={styles.partyValue}>{distributor.email}</Text>
              </View>
            )}
          </View>
        </View>
        
        {/* Tableau des produits */}
        <View>
          <View style={styles.tableHeader}>
            <Text style={[styles.tableHeaderCell, styles.col1]}>N°</Text>
            <Text style={[styles.tableHeaderCell, styles.col2]}>REF</Text>
            <Text style={[styles.tableHeaderCell, styles.col3]}>Désignation</Text>
            <Text style={[styles.tableHeaderCell, styles.col4]}>Qté</Text>
            <Text style={[styles.tableHeaderCell, styles.col5]}>Prix U.</Text>
            <Text style={[styles.tableHeaderCell, styles.col6]}>Total HT</Text>
          </View>
          
          {products && products.length > 0 ? products.map((product, idx) => {
            const itemTotal = (product?.price || 0) * (product?.quantity || 0);
            return (
              <View key={idx} style={[styles.tableRow, idx % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd]}>
                <Text style={[styles.tableCell, styles.col1]}>{idx + 1}</Text>
                <Text style={[styles.tableCell, styles.col2]}>{product?.reference || product?.productKey || "---"}</Text>
                <Text style={[styles.tableCell, styles.col3]}>{product?.name || "---"}</Text>
                <Text style={[styles.tableCell, styles.col4]}>{product?.quantity || 0}</Text>
                <Text style={[styles.tableCell, styles.col5]}>{(product?.price || 0).toFixed(2)} DA</Text>
                <Text style={[styles.tableCell, styles.col6]}>{itemTotal.toFixed(2)} DA</Text>
              </View>
            );
          }) : (
            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, styles.col1]}>-</Text>
              <Text style={[styles.tableCell, styles.col2]}>-</Text>
              <Text style={[styles.tableCell, styles.col3]}>Aucun produit</Text>
              <Text style={[styles.tableCell, styles.col4]}>-</Text>
              <Text style={[styles.tableCell, styles.col5]}>-</Text>
              <Text style={[styles.tableCell, styles.col6]}>-</Text>
            </View>
          )}
        </View>
        
        {/* Totaux */}
        <View style={styles.totalsContainer}>
          <View style={styles.totalsBox}>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Total HT:</Text>
              <Text style={styles.totalValue}>{totalHT.toFixed(2)} DA</Text>
            </View>
            {discountPercent > 0 && (
              <View style={styles.totalRow}>
                <Text style={styles.totalLabel}>Remise ({discountPercent}%):</Text>
                <Text style={styles.totalValue}>- {discountAmount.toFixed(2)} DA</Text>
              </View>
            )}
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>TVA ({(tvaRate * 100).toFixed(0)}%):</Text>
              <Text style={styles.totalValue}>{tva.toFixed(2)} DA</Text>
            </View>
            {timbreFiscal > 0 && (
              <View style={styles.totalRow}>
                <Text style={styles.totalLabel}>Droit de timbre:</Text>
                <Text style={styles.totalValue}>{timbreFiscal.toFixed(2)} DA</Text>
              </View>
            )}
            {timbreFiscal === 0 && paymentMethod !== 'cash' && totalTTC > 300 && (
              <View style={styles.totalRow}>
                <Text style={styles.totalLabel}>Droit de timbre:</Text>
                <Text style={styles.totalValue}>Exonéré (paiement électronique)</Text>
              </View>
            )}
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Mode de paiement:</Text>
              <Text style={styles.totalValue}>{getPaymentMethodText(paymentMethod)}</Text>
            </View>
            <View style={styles.netToPay}>
              <View style={styles.totalRow}>
                <Text style={styles.netToPayLabel}>NET À PAYER:</Text>
                <Text style={styles.netToPayValue}>{netAPayer.toFixed(2)} DA</Text>
              </View>
            </View>
          </View>
        </View>
        
        {/* Montant en lettres */}
        <View style={styles.amountInWords}>
          <Text style={styles.amountInWordsText}>
            Arrêté la présente facture à la somme de : {convertAmountToFrenchWords(netAPayer)} TOUTES TAXES COMPRISES
          </Text>
        </View>
        
        {/* Signatures */}
        <View style={styles.signatures}>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureText}>Cachet et Signature du Fournisseur</Text>
            <View style={styles.signatureLine} />
          </View>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureText}>Cachet et Signature du Client</Text>
            <View style={styles.signatureLine} />
          </View>
        </View>
        
        {/* Footer */}
        <View style={styles.footer} fixed>
          <View style={styles.footerLine} />
          <Text style={styles.footerText}>
            Pénalité de retard : taux d'intérêt légal majoré de 5 points. Indemnité forfaitaire pour frais de recouvrement : 40 DA
          </Text>
        </View>
        
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `Page ${pageNumber} / ${totalPages}`} fixed />
      </Page>
    </Document>
  );
};

export default InvoicePDF;